import styled, { keyframes } from 'styled-components';
import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import { FaTimes, FaUser, FaHome, FaChartLine, FaChartPie, FaCreditCard } from 'react-icons/fa';
import { HiOutlineCurrencyDollar } from 'react-icons/hi';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

export const TradesFormsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column; 
  min-width: 800px;
  height: 500px;
  display: flex;
  flexDirection: column; 
  overflow: scroll; 

  @media screen and (max-width: 490px){
    min-width: 300px;
    max-height: 400px;
  }

`
export const TradeRow = styled.div`
  background: white; 
  border: none;
  border-radius: 4px;
  color: black;
  font-size: 20px;
  cursor: pointer;
  margin: 1px 0px;
  height: 30px;
  width: 200px;
`

export const FormH1 = styled.h1`
  margin-bottom: 40px;
  color: #cc8f2d;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;


export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #cc8f2d;
  border-radius: 50%;
  margin-top: 112px;
  align-self: center;
  margin-bottom: 12px;
  width: 132px;
  height: 132px;
  animation: ${spin} 1s linear infinite;
`